import { FieldWrapper, getFieldErrorMessage } from "@birdwatch/ui/form";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import type { ReactNode } from "react";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input/input-otp";
import {
  type FieldBindingProps,
  PolyField,
  pickBinding,
} from "@/fields/_internal/poly-field";

type OtpFieldBaseProps = {
  maxLength?: number;
  label?: ReactNode;
  description?: ReactNode;
  className?: string;
  disabled?: boolean;
  onComplete?: () => void;
};

export type OtpFieldProps = OtpFieldBaseProps & FieldBindingProps;

export function OtpField(props: OtpFieldProps) {
  const {
    maxLength = 6,
    label,
    description,
    className,
    disabled,
    onComplete,
  } = props;
  const binding = pickBinding(props);
  return (
    <PolyField<string> {...binding}>
      {(field) => {
        const error = getFieldErrorMessage(field);
        return (
          <FieldWrapper
            label={label}
            description={description}
            error={error}
            className={className}
            disabled={disabled}
          >
            <InputOTP
              pattern={REGEXP_ONLY_DIGITS}
              maxLength={maxLength}
              value={field.state.value ?? ""}
              disabled={disabled}
              // No handleBlur, ever: an OTP has no blur, so its error is
              // revealed by a submit attempt or a server error only.
              onChange={(val) => field.handleChange(val)}
              onComplete={onComplete}
            >
              <InputOTPGroup>
                {Array.from({ length: maxLength }, (_, i) => (
                  <InputOTPSlot
                    // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length OTP slot grid, never reorders, no identity
                    key={i}
                    index={i}
                    className={
                      error
                        ? "border-border-negative-max data-[active=true]:ring-[1px]"
                        : "border-border-dark-low data-[active=true]:ring-[1px]"
                    }
                  />
                ))}
              </InputOTPGroup>
            </InputOTP>
          </FieldWrapper>
        );
      }}
    </PolyField>
  );
}
